<template>
  <el-drawer
    v-model="show"
    :size="1000"
    destroy-on-close
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <template #header>备注</template>
    <div class="toolbar">
      <Toolbar
        ref="toolbar"
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :default-config="toolbarConfig"
        :mode="mode"
      />
      <Editor
        v-model="form.remark"
        style="height: 200px; overflow-y: hidden"
        :default-config="editorConfig"
        :mode="mode"
        @on-created="handleCreated"
      />
    </div>
    <div class="btns">
      <el-button size="small" class="mr-10" @click="handleEmpty">清 空</el-button>
      <el-button :loading="loading" size="small" type="primary" @click="handleOk"> 保存</el-button>
    </div>

    <div v-loading="loading" class="mr-10">
      <el-timeline>
        <el-timeline-item
          v-for="(item, index) in items"
          :key="index"
        >
          <template #label>
            <el-card shadow="hover" class="mb-10">
              <Editor
                v-model="item.remark"
                :mode="mode"
                @on-created="handleCreated2"
              />
            </el-card>
          </template>

          <div class="f12" style="color: #9f9f9f;">
            {{ item.action_username + "  " + item.create_time }}
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>

    <div v-if="items.length===0" class="remarks noData">
      暂无备注
    </div>
  </el-drawer>
</template>

<script>
import "@wangeditor/editor/dist/css/style.css"; // 引入 css
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { postToolsFileBatchUpload, getRemarks, postRemarks } from "@/api/sso/tools";
import { ElMessage } from "element-plus";

export default {
  components: { Editor, Toolbar },
  data() {
    return {
      form: {},
      show: false,
      items: [],
      mode: "default",
      editor: null,
      toolbarConfig: {
        excludeKeys: ["group-video"],
        insertKeys: {
          index: 24, // 自定义插入的位置
          keys: ["uploadAttachment"] // “上传附件”菜单
        },
        modalAppendToBody: true
      },
      editorConfig: {
        placeholder: "请输入内容...",
        MENU_CONF: {
          uploadImage: {
            maxFileSize: 1024 * 1024,
            allowedFileTypes: ["image/png", "image/jpeg"],
            customUpload(file, insertFn) {
              const fd = new FormData();
              fd.append("file", file);
              fd.append("name", "user.remark.file");
              const config = { headers: { "Content-Type": "multipart/form-data" } };
              postToolsFileBatchUpload(fd, config).then(res => {
                ElMessage.success("上传成功");
                insertFn(res.data.success_list[0].url, file.name, "");
              });
            }
          },
          uploadAttachment: {
            maxFileSize: 1024 * 1024,
            allowedFileTypes: ["application/pdf"],
            // 用户自定义上传
            customUpload(file, insertFn) {
              const fd = new FormData();
              fd.append("file", file);
              fd.append("name", "user.remark.file");
              const config = { headers: { "Content-Type": "multipart/form-data" } };
              postToolsFileBatchUpload(fd, config).then(res => {
                ElMessage.success("上传成功");
                insertFn(file.name, res.data.success_list[0].url);
              });
            }
          }
        },
        hoverbarKeys: {
          attachment: {
            menuKeys: ["downloadAttachment"] // “下载附件”菜单
          }
        }
      },
      editor2: null,
      loading: false
    };
  },
  beforeUnmount() {
    const { editor } = this;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
  methods: {
    handleCreated(editor) {
      this.editor = Object.seal(editor); // 记录 editor 实例，重要！
    },
    handleCreated2(editor) {
      this.editor2 = Object.seal(editor); // 记录 editor 实例，重要！
      this.editor2.disable();
    },
    // 打开弹窗
    handleOpen(val) {
      this.form = { user_id: val.id, remark: "", type: this.$route.meta.products };
      this.show = true;

      this.getAdminClientsRemarkInfo();
    },
    getAdminClientsRemarkInfo() {
      this.loading = true;
      getRemarks({ user_id: this.form.user_id, type: this.form.type, isMask: true })
        .then((res) => {
          this.items = res.data;
          this.loading = false;
        }).catch(() => {
        this.loading = false;
      });
    },
    // 关闭弹窗
    handleClose() {
      this.show = false;
    },
    // 保存
    handleOk() {
      if (!this.form.remark.trim() || this.form.remark.trim() === "<p><br></p>") {
        this.$message.error("内容不能为空！");
        return;
      }
      this.loading = true;
      postRemarks({ ...this.form, isMask: true })
        .then(() => {
          this.$message.success("保存成功！");
          this.getAdminClientsRemarkInfo();
          this.handleEmpty();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleEmpty() {
      this.form.remark = "";
    }
  }
};
</script>

<style scoped lang="less">
.toolbar {
  height: 300px;
  margin: 0 20px;
  border: 1px solid #ccc;
}

.btns {
  text-align: right;
  padding: 20px;
}

.remarks {
  border: 1px solid #ccc;
  margin: 0 20px;
  height: 450px;

  .left {
    width: 150px;
    border-right: 1px solid #f5f7f9;
    overflow: auto;
    height: 100%;

    .item-date {
      // text-align: center;
      // font-size: 18px;
      // line-height: 40px;
      padding: 10px;
      border-radius: 4px;
      cursor: pointer;

      &:hover {
        background-color: #333;
        color: #fff;
      }
    }

    .isActive {
      color: #fff;
      background-color: #409EFF;
    }
  }

  ::v-deep .right {
    overflow: auto;
    padding: 20px;

    a {
      background-color: rgb(241, 241, 241);
      padding: 4px 4px;
      border-radius: 4px;
    }

    img {
      max-width: 100%;
    }
  }
}

.noData {
  font-size: 20px;
  color: #abb2bf;
  text-align: center;
  line-height: 100px;
}
</style>
